import { render, staticRenderFns } from "./IsHot.vue?vue&type=template&id=25d453ad&scoped=true"
import script from "./IsHot.vue?vue&type=script&lang=js"
export * from "./IsHot.vue?vue&type=script&lang=js"
import style0 from "./IsHot.vue?vue&type=style&index=0&id=25d453ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d453ad",
  null
  
)

export default component.exports